export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const UPDATE_DASHBOARD_LIST_FIELD = 'UPDATE_DASHBOARD_LIST_FIELD';
export const UPDATE_DASHBOARD_CHART_FIELD = 'UPDATE_DASHBOARD_CHART_FIELD';